//import {TutorialPhase} from '../components/game-flow-controller.js';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class UIModel extends NotifyPropertyChanged {
    private static _instance: UIModel;
    private _isPopupActive: boolean;

    static get instance(): UIModel {
        return this._instance ?? (this._instance = new UIModel());
    }

    static readonly ACTIVE_MENU_CHANGED = 'activeMenus';

    private constructor() {
        super();
    }

    private _activeMenus: Map<MenuPanels, boolean> = new Map();
    private _hudActive: boolean = false;
    private _tutorialHudActive: boolean = false;
    private _showNextRewardLabel: boolean = false;
    private _nextRewardLabel: string = '';

    get showNextRewardLabel(): boolean {
        return this._showNextRewardLabel;
    }
    get nextRewardLabel(): string {
        return this._nextRewardLabel;
    }

    isMenuActive(menu: MenuPanels): boolean {
        return this._activeMenus.get(menu) || false;
    }

    isHUDActive(): boolean {
        return this._hudActive;
    }
    isTutorialHudActive(): boolean {
        return this._tutorialHudActive;
    }
    isPopupActive(): boolean {
        return this._isPopupActive;
    }

    getAllActiveMenus(): MenuPanels[] {
        const activeMenus = Array.from(this._activeMenus.entries())
            .filter(([, active]) => active)
            .map(([menu]) => menu);
        return activeMenus;
    }

    setMenuActive(menu: MenuPanels, active: boolean): void {
        // check if the menu should change.
        if (this._activeMenus.get(menu) !== active) {
            this._activeMenus.set(menu, active);
        }
        this.propertyChanged.notify(UIModel.ACTIVE_MENU_CHANGED);
    }
    setHUDActive(active: boolean) {
        if (this._hudActive !== active) {
            this._hudActive = active;
        }
        this.propertyChanged.notify(UIModel.ACTIVE_MENU_CHANGED);
    }
    setTutorialHUDActive(active: boolean) {
        if (this._tutorialHudActive !== active) {
            this._tutorialHudActive = active;
        }
        this.propertyChanged.notify(UIModel.ACTIVE_MENU_CHANGED);
    }
    hideAll() {
        this._activeMenus.clear();
        this._hudActive = false;
        this._tutorialHudActive = false;
        this.propertyChanged.notify(UIModel.ACTIVE_MENU_CHANGED);
    }

    // private _currentTutorialPhase: TutorialPhase;
    // get currentTutorialPhase(): TutorialPhase {
    //     return this._currentTutorialPhase;
    // }
    // setTutorialPhase(phase: TutorialPhase) {
    //     this._currentTutorialPhase = phase;
    //     this.propertyChanged.notify('TutorialPhase');
    // }

    setPopupActive(active: boolean) {
        this._isPopupActive = active;
        this.propertyChanged.notify('PopupActive');
    }

    setShowNextRewardLabel(show: boolean) {
        this._showNextRewardLabel = show;
        this.propertyChanged.notify('ShowNextRewardLabel');
    }

    setNextRewardLabel(label: string) {
        this._nextRewardLabel = label;
        this.propertyChanged.notify('NextRewardLabel');
    }

    private _isUILoaded: boolean = false;

    get isUILoaded(): boolean {
        return this._isUILoaded;
    }

    setUILoaded(): void {
        this._isUILoaded = true;
        this.propertyChanged.notify('UILoaded');
    }
}

export enum MenuPanels {
    MainMenu,
    Malwear,
    StorePowerups,
    MissionRequirements,
    StageSelect,
    LeaderboardInvite,
    InstructionalText,
    Shoppe,
    StorePowerupsPopup,
    Games,
    StoreCoins,
    Loadout,
    Rewards,
    StorePerks,
    Share,
    Tutorial,
    Options,
    LeaderboardStats,
    Leaderboard,
    Loadout2,
    Credits,
    Support,
    ModeSelect,
    Stats,
    StoreSpecialOffers,
    StorePerksPopup,
    Pause,
    Achievements,
    GameOver,

    YesNoDialog,
    GetDailyReward,
    Curtains,
    UnlockedSometing,
    Tip,
    RankedUpReward,
    UnlockRequirements,
    SkipMission,
    PopupInstructionalTextMenus,
}
